import { Component, Input } from '@angular/core';

@Component({
  selector: 'bn-bn-app-state-widget',
  templateUrl: './bn-app-state-widget.component.html',
  styleUrls: ['./bn-app-state-widget.component.scss'],
})
export class BnAppStateWidgetComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() code: 'not-found' | 'forbidden' | 'server-error' = 'not-found';

  constructor() {}
}
